import { useEffect } from 'react';

export default function SharepointAuthSuccess() {
    useEffect(() => {
        if (window.opener) {
            window.opener.postMessage(
                { sharepointConnected: true },
                process.env.REACT_APP_FRONT_BASE_URL
            );
        }
        window.close();
    }, []);

    return null;
}
